module.exports = require("core-js/modules/es.promise.finally.js");